import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "./axiosBaseQuery";
import {parseHotYoterPageResponse} from "../../containers/hot_yoter/utils/parseHotYoterPageResponse";

export const contentApi = createApi({
    reducerPath: 'contentApi',
    baseQuery: axiosBaseQuery({
        baseUrl: '/content/api',
    }),
    tagTypes: ['contents'],
    endpoints: (build) => ({
        getArticleById: build.query({
            query: (id) => ({
                url: `/articles/${id}`,
                params: {
                    articleId: id
                }
            }),
        }),
        getVideoArticles: build.mutation({
            query: (page) => ({
                url: '/articles/video',
                params: {
                    pageNumber: page,
                    pageNum: page
                }
            })
        }),
        getVideoArticle: build.query({
            query: (id) => ({
                url: `/articles/video/${id}`,
                params: {
                    articleId: id
                }
            })
        }),
        getVideoArticles: build.query({
            query: (page) => ({
                url: '/articles/video',
                params: {
                    pageNumber: page,
                    pageNum: page
                }
            })

        }),
        getMagazine: build.query({
            query: () => ({
                url: '/articles/magazine'
            }),
        }),
        getArticlesByCategory: build.query({
            query: ({categoryId, pageNumber}) => ({
                url: '/articles/category',
                params: {
                    categoryId,
                    pageNumber
                },
            }),

        }),
        getVideoArticlesCategoryByPageNumber: build.query({
            query: ({pageNumber}) => ({
                url: '/articles/getVideoArticlesCategoryByPageNumber',
                params: {
                    pageNumber
                }
            })
        }),

        markArticleView: build.mutation({
            query: (id) => ({
                url: `/articles/${id}/view`,
                method: 'POST',
                params: {
                    articleId: id
                }
            })
        }),
        getPageById: build.query({
            query: (id) => ({
                url: `/pages/id/${id}`,
            }),
        }),
        getOurStory: build.query({
            query: () => ({
                url: `/pages/our-story`,
            })
        }),
        getBenefitsPage: build.query({
            query: ({name}) => ({
                url: `/pages/benefits/${encodeURIComponent(name)}`,
                popupOnError: false
            }),
        }),
        getPresentBenefitsPage: build.query({
            query: ({name}) => ({
                url: `/pages/present-benefits/${encodeURIComponent(name)}`,
                popupOnError: false
            }),
        }),
        getCustomerJoinData: build.query({
            query: ({pageName}) => ({
                url: `/pages/users-application/${pageName|| ''}`
            }),
        }),
        getLandingPage: build.query({
            query: ({slug}) => ({
                url: `/pages/landing-pages/${slug || ''}`,
            })
        }),
        getBannersPage: build.query({
            query: ({name}) => ({
                url: `/pages/banners-page/${encodeURIComponent(name)}`,
                popupOnError: false
            }),
        }),
        getLandingJoinContentPage: build.query({
            query: ({slug}) => ({
                url: `/pages/content-pages/${slug|| ''}`,
                popupOnError: false
            }),
        }),
        getPresentsBenefitsPage: build.query({
            query: ({name}) => ({
                url: `/pages/benefits-banners-page/${encodeURIComponent(name)}`,
                popupOnError: false
            }),
        }),
        getHotYoterPage: build.query({
            query: ({ slug }) => ({
                url: `/pages/benefits/hotyoter/${encodeURIComponent(slug)}`,
                popupOnError: false,
            }),
            transformResponse: (response) => {
                const rawData = response?.data ?? response;
                return parseHotYoterPageResponse(rawData) ?? rawData;
            },
        }),
        getRecommendationsSlider: build.query({
            query: () => ({
                url: '/homepage/recommendations-slider',
                popupOnError: false,
            }),
        }),
        getHotYoterStatePanel: build.query({
            query: () => ({
                url: '/homepage/hot-yoter/state-pannel',
                params: {
                    t: Date.now(),
                },
                popupOnError: false,
            }),
        }),
    })
})


export const {
    useGetPageByIdQuery,
    useGetOurStoryQuery,
    useGetArticleByIdQuery,
    useGetVideoArticleQuery,
    useGetVideoArticlesQuery,
    useGetMagazineQuery,
    useGetArticlesByCategoryQuery,
    useGetVideoArticlesCategoryByPageNumberQuery,
    useMarkArticleViewMutation,
    useGetBenefitsPageQuery,
    useGetPresentBenefitsPageQuery,
    useLazyGetPresentBenefitsPageQuery,
    useGetCustomerJoinDataQuery,
    useGetLandingPageQuery,
    useGetLandingJoinContentPageQuery,
    useGetBannersPageQuery,
    useGetPresentsBenefitsPageQuery,
    useGetHotYoterPageQuery,
    useGetRecommendationsSliderQuery,
    useGetHotYoterStatePanelQuery,
} = contentApi


